
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certificate/lp/[subscriptionId]",
      function () {
        return require("private-next-pages/certificate/lp/[subscriptionId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certificate/lp/[subscriptionId]"])
      });
    }
  